import Vue from "vue";
import App from "./App.vue";
import {pm} from "./router";
import store from "./store";
// import bus from "vue-bus"; // 发布订阅
import "./styles/common.scss";
// 引入 element组件库
import ElementUI from "element-ui";
// 引入 element 主题文件
import "element-ui/lib/theme-chalk/index.css";
import "@/styles/index.scss";
// 引入阿里矢量图
import "./assets/font/iconfont.css";
// PDF
import htmlToPdf from './utils/htmlToPdf'
Vue.use(htmlToPdf)

// 引入封装的浏览器存储
import storage from "./utils/storage";
// 浏览器存储
Vue.prototype.$storage = storage;
// 引入封装的导出表格
import {downloadExcel} from "@/utils/excel";
// 导出表格
Vue.prototype.$downloadExcel = downloadExcel;

import VueAliplayerV2 from 'vue-aliplayer-v2';
Vue.use(VueAliplayerV2);

//数据的快速复制
import objCopy from './utils/objCoppy'
Vue.prototype.$objCopy = objCopy;
//全局公用方法
import commonUtils from './utils/commonUtils'
Vue.prototype.$utils = commonUtils;
// 引入时间转换moment
import moment from "moment";
//屏幕适配方案
import './utils/rem'
// 注册为Vue插件
Vue.use(ElementUI);
Vue.prototype.$store = store;
// Vue.use(bus); // 发布订阅
// 时间转换
Vue.prototype.$moment = moment;
Vue.config.productionTip = false;
// Vue.prototype.$EventBus = new Vue();
Vue.prototype.$bus = new Vue();
pm.then((router)=>{
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
})
